import { Link, useLocation } from 'react-router-dom';
import { getChosenSchool } from '../shared';
import { AppSchoolHeader } from '@/components/AppSchoolHeader';

export function ApplyLandingPage() {
  const chosen = getChosenSchool();
  const { search } = useLocation(); // ?school=CODE from the school's shared apply link
  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-white">
      <div className="hidden md:flex flex-col justify-center bg-[#0A2540] px-12 lg:px-20">
        <h1 className="text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
          {chosen?.name ?? 'Myschool Portal'}
        </h1>
        <p className="text-slate-300 mt-4 text-base lg:text-lg">Apply for admission</p>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 md:px-12 lg:px-20">
        <div className="w-full max-w-md mx-auto space-y-6">
          <AppSchoolHeader subtitle="Apply for admission" />
          <div>
            <h2 className="text-3xl font-extrabold text-[#0A2540]">Apply for admission</h2>
            <p className="text-sm text-slate-500 mt-2">
              Start a new application, or sign in to continue one you already started.
            </p>
          </div>
          <div className="space-y-3">
            <Link to={`/apply/register${search}`}
              className="block w-full text-center bg-[#0A2540] hover:bg-[#0f2f54] text-white font-semibold py-3.5 rounded-lg">
              Start a new application
            </Link>
            <Link to="/login"
              className="block w-full text-center border-2 border-green-700 text-green-800 hover:bg-green-50 font-semibold py-3 rounded-lg">
              Sign in to continue
            </Link>
          </div>
          <div className="text-center">
            <Link to="/login" className="text-sm text-slate-500 hover:text-[#0A2540] hover:underline">
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
